import { Helmet } from 'react-helmet-async';
import { BlogView } from 'src/sections/blog/view';

export default function BlogPage() {
  return (
    <>
      <Helmet>
        <title>Blog & Resources - Cartify</title>
        <meta
          name="description"
          content="Discover insights, tips, and success stories about restaurant sourcing, supplier relationships, and industry trends. Stay ahead with Cartify's thought leadership content."
        />
      </Helmet>
      <BlogView />
    </>
  );
}
